// extracted by mini-css-extract-plugin
export default {"Logo":"Login_Logo__Gdd3e","Abstract":"Login_Abstract__0oa45"};